import React from 'react'
import styled from 'styled-components'

import logo_white from '../img/UB_logotyp_cremevit_RGB.png'
import logo_grey from '../img/UB_logotyp_gra_RGB.png'

import { UIStore } from '../stores/UIStore'
import { observer } from 'mobx-react'
import { colors } from '../variables'
import { Container, Row, Col, Hidden, Visible } from 'react-grid-system'

export const Footer = observer(() => {
  const bg =
    UIStore.footerBg !== '' ? UIStore.footerBg : UIStore.backgroundShade

  return (
    <FooterDivHolder bg={bg}>
      <StyledContainer>
        <Row>
          <Col sm={5}>
            <FooterLeft>
              <h1
                style={{
                  color: bg === colors.green ? colors.orange : colors.green,
                }}
              >
                Ta kontakt med oss redan idag
              </h1>
              <Hidden xs>
                <Logo
                  alt="Logo"
                  src={bg === colors.green ? logo_white : logo_grey}
                />
              </Hidden>
            </FooterLeft>
          </Col>
          <Col sm={1} />
          <Col sm={6}>
            <FooterRight>
              <p>
                Vill du bli konsult?
                <br />
                <a href="mailto:konsult@utvecklarbolaget.se">
                  konsult@utvecklarbolaget.se
                </a>
              </p>
              <p>
                Vill du bli kund?
                <br />
                <a href="mailto:kund@utvecklarbolaget.se">
                  kund@utvecklarbolaget.se
                </a>
              </p>
            </FooterRight>
            <Visible xs>
              <Logo
                alt="Logo"
                src={bg === colors.green ? logo_white : logo_grey}
              />
            </Visible>
          </Col>
        </Row>
      </StyledContainer>
    </FooterDivHolder>
  )
})

export default Footer

const FooterDivHolder = styled.div`
  background-color: ${({ bg }: { bg: string }) => bg};
  width: 100vw;
  position: fixed;
  bottom: 0;
  z-index: -1;
  font-size: 18px;
  line-height: 22px;

  & > * {
    color: ${({ bg }: { bg: string }) =>
      bg === colors.green ? colors.white : colors.green};
  }
`

const StyledContainer = styled(Container)`
  padding: 40px 25px 50px;

  @media (min-width: 769px) {
    padding: 80px 0 100px;
  }
`

const FooterLeft = styled.div`
  h1 {
    font-size: 38px;
    line-height: 42px;
    margin-bottom: 30px;

    @media (min-width: 769px) {
      font-size: 64px;
      line-height: 1.09;
      margin-bottom: 90px;
    }
  }
`

const FooterRight = styled.div`
  font-size: 17px;
  line-height: 28px;
  margin-left: 0;

  @media (min-width: 769px) {
    font-size: 22px;
    line-height: 1.55;
    margin-left: 60px;
  }

  p,
  a {
    font-family: 'Miriam Libre';
  }
`

const Logo = styled.img`
  width: 220px;

  @media (min-width: 769px) {
    width: 320px;
  }
`
